import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {UsersService} from '../../../core/services/users.service';
import {ShadeToolsService} from '../../../core/services/shade-tools.service';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {LoginHelpButtonsComponent} from '../../components/login-help-buttons/login-help-buttons.component';
import {NgClass} from '@angular/common';
import {SpinnerComponent} from '../../components/spinner/spinner.component';
import {FormsModule} from '@angular/forms';
import {UtilsService} from '../../../core/services/utils.service';

@Component({
  selector: 'motn-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    LoginHelpButtonsComponent,
    NgClass,
    SpinnerComponent,
    FormsModule,
  ],
})
export class PasswordResetComponent implements OnInit, OnDestroy {
  enteredUsername: string = '';
  submittingUsername: boolean = false;
  submittedUsername: boolean = false;

  resetCode: string = '';
  enteredPassword1: string = '';
  enteredPassword2: string = '';
  submittingPassword: boolean = false;
  submittedPassword: boolean = false;

  routeSub: Subscription;


  constructor(
    private userService: UsersService,
    private shadeTools: ShadeToolsService,
    private route: ActivatedRoute,
  ) {
  }


  ngOnInit(): void {
    this.route.queryParams.subscribe(
      (params) => {
        this.resetCode = params['code'];
      },
    );
  }


  ngOnDestroy() {
    this.routeSub?.unsubscribe();
  }


  createPasswordReset() {
    this.submittingUsername = true;

    this.userService.createPasswordReset$(this.enteredUsername).subscribe(
      () => {
        this.submittedUsername = true;
      },
      () => {
        this.submittingUsername = false;
        this.shadeTools.errorDialog();
      },
    );
  }


  performPasswordReset() {
    if (this.enteredPassword1 !== this.enteredPassword2) {
      this.shadeTools.errorDialog('The passwords do not match.');
      return;
    }

    this.submittingPassword = true;

    this.userService.performPasswordReset$(this.resetCode, this.enteredPassword1).subscribe(
      () => {
        this.enteredPassword1 = '';
        this.enteredPassword2 = '';
        this.submittedPassword = true;
      },
      (err: HttpErrorResponse) => {
        this.submittingPassword = false;

        const errorMessage = UtilsService.extractErrorMessage(err.error);
        if (errorMessage.includes('expired')) {
          this.shadeTools.errorDialog('This password reset link has expired. Please submit a new password reset request.');

          // To dodge browsers' attempts to save the password,
          // clear passwords and use setTimeout to force the
          // view change after the inputs have been updated
          this.enteredPassword1 = '';
          this.enteredPassword2 = '';
          setTimeout(() => this.resetCode = '', 0);
        } else if (err.status >= 400 && err.status < 500) {
          this.shadeTools.errorDialog(`Your submission failed for the following reason: ${errorMessage}`);
        } else {
          this.shadeTools.errorDialog();
        }
      },
    );
  }
}
